import numeral from 'numeral';

export function formatCents(value: number): string {
  if (typeof value !== 'number') {
    throw new Error('Invalid value passed to formatCents!');
  }

  return numeral(value / 100).format('$0,0.00');
}
